import * as React from 'react';
import { useSelector } from 'react-redux';

import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import { TourSlideContainer } from 'shared/containers/TourSlideContainer';
import { selectTourV2 } from 'shared/selectors/offerData/tour/selectTourV2';
import { selectTourV2BannerImageUrlV2 } from 'shared/selectors/offerData/tour/selectTourV2BannerImageUrl';

export const use3D = (): TMedia | null => {
  const tour = useSelector(selectTourV2);
  const thumbnailSrc = useSelector(selectTourV2BannerImageUrlV2);

  return React.useMemo<TMedia | null>(() => {
    if (!tour) {
      return null;
    }

    return tour && thumbnailSrc
      ? {
          type: EMediaType.Tour,
          component: <TourSlideContainer />,
          thumbnailSrc,
        }
      : null;
  }, [thumbnailSrc, tour]);
};
